import { initContract } from '@ts-rest/core'
import { z } from 'zod'

const c = initContract()
const prefix = '/v2/holidays'

// Schema definitions
const HolidaySchema = z
  .object({
    id: z.string(),
    name: z.string(),
    startDate: z.union([z.string(), z.date()]),
    endDate: z.union([z.string(), z.date()]),
  })
  .passthrough()

// Contract
export const holiday = c.router({
  getAll: {
    method: 'GET',
    path: `${prefix}`,
    responses: {
      200: z.array(HolidaySchema),
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Get all holidays',
  },
})
